import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
const List = styled.dl.withConfig({ displayName: "vui--List", componentId: "vui--syirga" }) `margin:unset;& > * + *{margin-top:${theme.sizes.base};}`;
const Item = styled.div.withConfig({ displayName: "vui--Item", componentId: "vui--dz7dgm" }) `& > * + *{margin-top:${theme.sizes.xs};}`;
const ItemRow = styled.div.withConfig({ displayName: "vui--ItemRow", componentId: "vui--1b0o5wp" }) `display:flex;justify-content:space-between;& > * + *{margin-left:${theme.sizes.base};}`;
const DescriptionContainer = styled.div.withConfig({ displayName: "vui--DescriptionContainer", componentId: "vui--foltw8" }) `text-align:right;& > * + *{margin-top:${theme.sizes.xs};}`;
const Term = styled.dt.withConfig({ displayName: "vui--Term", componentId: "vui--s2cfux" }) `font-family:${theme.text.bodyBold.fontFamily};font-size:${theme.text.bodyBold.fontSize};font-weight:${theme.text.bodyBold.fontWeight};line-height:${theme.text.bodyBold.lineHeight};color:${theme.text.bodyBold.color};`;
const Description = styled.dd.withConfig({ displayName: "vui--Description", componentId: "vui--1915ejg" }) `margin-left:unset;font-family:${theme.text.body.fontFamily};font-size:${theme.text.body.fontSize};font-weight:${theme.text.body.fontWeight};line-height:${theme.text.body.lineHeight};color:${theme.text.body.color};`;
export const DescriptionList = ({ items, horizontal }) => {
    const renderDescription = (description) => {
        if (Array.isArray(description)) {
            return description.map((d) => React.createElement(Description, { key: d }, d));
        }
        return React.createElement(Description, null, description);
    };
    const renderItem = (item) => {
        if (horizontal) {
            return (React.createElement(ItemRow, { key: item.term },
                React.createElement(Term, null, item.term),
                React.createElement(DescriptionContainer, null, renderDescription(item.description))));
        }
        return (React.createElement(Item, { key: item.term },
            React.createElement(Term, null, item.term),
            renderDescription(item.description)));
    };
    return React.createElement(List, null, items.map(renderItem));
};
//# sourceMappingURL=DescriptionList.js.map